// ===== スクロールアニメーション実装 =====
document.addEventListener('DOMContentLoaded', function () {
  // アニメーション対象の要素を取得
  const fadeElements = document.querySelectorAll('.fade-in');

  // Intersection Observerを作成
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 要素が表示領域に入ったら'visible'クラスを追加
          entry.target.classList.add('visible');
          // 一度表示されたら監視を解除（パフォーマンス向上）
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.2, // 要素が20%表示されたら発火
      rootMargin: '0px 0px -50px 0px', // 下から50px手前で発火（より自然なタイミング）
    }
  );

  // 各要素を監視開始
  fadeElements.forEach((el) => observer.observe(el));
});

// ===== YouTube動画スライドショー実装 =====
class VideoSlideshow {
  constructor() {
    this.currentSlideIndex = 0;
    this.slides = document.querySelectorAll('.video-slide');
    this.prevBtn = document.querySelector('.prev-btn');
    this.nextBtn = document.querySelector('.next-btn');
    this.totalSlides = this.slides.length;

    this.init();
  }

  init() {
    // ナビゲーションボタンのイベントリスナー
    if (this.prevBtn && this.nextBtn) {
      this.prevBtn.addEventListener('click', () => this.previousSlide());
      this.nextBtn.addEventListener('click', () => this.nextSlide());
    }

    // キーボードイベントリスナー
    document.addEventListener('keydown', (e) => this.handleKeyboard(e));

    // 初期表示
    this.showSlide(0);
  }

  showSlide(index) {
    // 範囲チェック（無限ループ対応）
    if (index < 0) {
      index = this.totalSlides - 1;
    } else if (index >= this.totalSlides) {
      index = 0;
    }

    // 現在のスライドを非表示
    this.slides[this.currentSlideIndex].classList.remove('active');

    // 新しいスライドを表示
    this.currentSlideIndex = index;
    this.slides[this.currentSlideIndex].classList.add('active');
  }

  nextSlide() {
    this.showSlide(this.currentSlideIndex + 1);
  }

  previousSlide() {
    this.showSlide(this.currentSlideIndex - 1);
  }

  goToSlide(index) {
    this.showSlide(index);
  }

  handleKeyboard(e) {
    // 動画スライドショーが存在する場合のみ処理
    if (!document.querySelector('.video-slideshow')) return;

    switch (e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        this.previousSlide();
        break;
      case 'ArrowRight':
        e.preventDefault();
        this.nextSlide();
        break;
      case 'Home':
        e.preventDefault();
        this.goToSlide(0);
        break;
      case 'End':
        e.preventDefault();
        this.goToSlide(this.totalSlides - 1);
        break;
    }
  }
}

// DOMContentLoadedイベントでスライドショーを初期化
document.addEventListener('DOMContentLoaded', function () {
  // 動画スライドショーが存在する場合のみ初期化
  if (document.querySelector('.video-slideshow')) {
    new VideoSlideshow();
  }
});

// ===== ハンバーガーメニュー実装 =====
document.addEventListener('DOMContentLoaded', function () {
  const hamburgerBtn = document.getElementById('js-hamburger');
  const globalNav = document.getElementById('global-nav');

  if (hamburgerBtn && globalNav) {
    hamburgerBtn.addEventListener('click', function () {
      // aria-expanded の状態を取得
      const isExpanded = hamburgerBtn.getAttribute('aria-expanded') === 'true';

      // 状態を切り替え
      if (isExpanded) {
        // メニューを閉じる
        hamburgerBtn.setAttribute('aria-expanded', 'false');
        hamburgerBtn.setAttribute('aria-label', 'メニューを開く');
        hamburgerBtn.classList.remove('is-active');
        globalNav.classList.remove('is-active');
      } else {
        // メニューを開く
        hamburgerBtn.setAttribute('aria-expanded', 'true');
        hamburgerBtn.setAttribute('aria-label', 'メニューを閉じる');
        hamburgerBtn.classList.add('is-active');
        globalNav.classList.add('is-active');
      }
    });

    // メニュー内のリンクをクリックしたらメニューを閉じる
    const navLinks = globalNav.querySelectorAll('a');
    navLinks.forEach((link) => {
      link.addEventListener('click', function () {
        hamburgerBtn.setAttribute('aria-expanded', 'false');
        hamburgerBtn.setAttribute('aria-label', 'メニューを開く');
        hamburgerBtn.classList.remove('is-active');
        globalNav.classList.remove('is-active');
      });
    });
  }
});

/* ===== カスタマイズポイント ===== */
/*
【発火タイミングの調整】
- threshold: 0.2 を変更：
  - 0.1：要素が10%表示されたら発火（早め）
  - 0.5：要素が50%表示されたら発火（遅め）
  - 1.0：要素が完全に表示されたら発火（最も遅い）

【発火位置の調整】
- rootMargin: "0px 0px -50px 0px" を変更：
  - "0px 0px 0px 0px"：要素が表示領域に入った瞬間
  - "0px 0px -100px 0px"：下から100px手前で発火
  - "50px 0px 0px 0px"：上から50px手前で発火

【複数回アニメーション】
- observer.unobserve(entry.target); を削除すると、
  要素が表示領域を出入りするたびにアニメーションが実行される

【スライドショー機能】
- 左右矢印キーでスライド切り替え
- Home/Endキーで最初/最後のスライドに移動
- マウス/タッチ操作でナビゲーション
- アクセシビリティ対応（ARIA属性、キーボード操作）
*/

// ===== お客様の声 続きを読む =====
document.addEventListener('DOMContentLoaded', function () {
  const expandableVoices = document.querySelectorAll('.js-expandable-voice');

  expandableVoices.forEach((voice) => {
    const shortText = voice.querySelector('.short-text');
    const fullText = voice.querySelector('.full-text');
    const button = voice.querySelector('.js-expand-button');

    if (!shortText || !fullText || !button) return;

    button.addEventListener('click', function () {
      const isExpanded = fullText.style.display === 'block';

      if (isExpanded) {
        // 閉じる
        fullText.style.display = 'none';
        shortText.style.display = 'block';
        button.textContent = '続きを読む';
      } else {
        // 開く
        fullText.style.display = 'block';
        shortText.style.display = 'none';
        button.textContent = '閉じる';
      }
    });
  });
});

// ===== Fade In Up アニメーション =====
document.addEventListener('DOMContentLoaded', function () {
  const target = document.getElementById('fadeinup');

  if (!target) return;

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target); // 一度だけ実行
        }
      });
    },
    {
      threshold: 0.5, // 要素が50%表示されたら発火
      rootMargin: '0px 0px -50px 0px', // 下から50px手前で発火（より自然なタイミング）
    }
  );

  observer.observe(target);
});

// ===== 地図ピン bounceIn アニメーション =====
// 地図が画面に表示されたら、ピンがバウンスしながら表示されるアニメーション
/* ===== カスタマイズ方法 ===== */
/*
【アニメーション発火タイミングの調整】
- 247行目：entry.intersectionRatio >= 0.5
  - 0.5 → 0.3：画像が30%表示されたら発火（早め）
  - 0.5 → 0.7：画像が70%表示されたら発火（遅め）
  - 0.5 → 1.0：画像が完全に表示されたら発火（最も遅い）

【アニメーション速度の調整】
- scss/_sections.scss 1546行目：animation-duration: 1.5s;
  - 1.5s → 1.0s：より速く
  - 1.5s → 2.0s：よりゆっくり

【ピンの表示順序を変更する場合】
- 249行目の pins.forEach を変更して、setTimeout で遅延を追加
  例：pins.forEach(function (pin, index) {
        setTimeout(function() {
          pin.classList.add('bounce-in-play');
          ...
        }, index * 100); // 0.1秒ずつずらして表示
      });

【複数回アニメーションを実行する場合】
- 258行目：io.unobserve(mapImage); を削除
  ※ただし、252-255行目のクラス削除処理も調整が必要
*/
document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector('.map-container');
  if (!container) return;

  var pins = container.querySelectorAll('.map-pin');
  if (!pins.length) return;

  // 初期状態を各ピンに適用
  pins.forEach(function (pin) {
    pin.classList.add('bounce-in-ready');
  });

  // .map-senjuの画像を監視対象に
  var mapImage = container.querySelector('.map-senju img');
  if (!mapImage) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        // シンプルに50%以上表示されたら発火
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          // すべてのピンを一斉に再生
          pins.forEach(function (pin) {
            pin.classList.add('bounce-in-play');
            pin.addEventListener(
              'animationend',
              function () {
                pin.classList.remove('bounce-in-ready', 'bounce-in-play');
                pin.style.opacity = '1';
                pin.style.transform = 'none';
              },
              { once: true }
            );
          });

          io.unobserve(mapImage);
        }
      });
    },
    {
      threshold: [0, 0.25, 0.5, 0.75, 1],
    }
  );

  io.observe(mapImage);
});
